'use strict';

const base = require('./base');
const siteAlert = require('../components/alert');

/**
 * @description returns text to display
 * @param {string} text - full text
 * @param {number} maxWords - maximum number of words
 * @returns {string} text to display
 */
function getMainInfoText(text, maxWords) {
    return text.split(' ').splice(0, maxWords).join(' ');
}

/**
 * Enable/disable UI elements
 * @param {boolean} enableOrDisable - true or false
 */
function updateAddToCartEnableDisableOtherElements(enableOrDisable) {
    $('button.add-to-cart-global').attr('disabled', enableOrDisable);
}

/**
 * Copies text to user buffer
 * @param {string} text - text
 */
function copy(text) {
    if (!text) return;

    let input = document.createElement('input');

    input.setAttribute('value', text);
    document.body.appendChild(input);
    input.select();

    document.execCommand('copy');
    document.body.removeChild(input);
}

module.exports = {
    methods: {
        updateAddToCartEnableDisableOtherElements: updateAddToCartEnableDisableOtherElements
    },

    availability: base.availability,

    addToCart: base.addToCart,

    updateAttributesAndDetails: function () {
        $('body').on('product:statusUpdate', function (e, data) {

        });
    },

    showSpinner: function () {
        $('body').on('product:beforeAddToCart product:beforeAttributeSelect', function () {
            $.spinner().start();
        });
    },
    updateAttribute: function () {
        $('body').on('product:afterAttributeSelect', function (e, response) {
            if ($('.product-detail>.bundle-items').length) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else if ($('.product-set-detail').eq(0)) {
                response.container.data('pid', response.data.product.id);
                response.container.find('.product-id').text(response.data.product.id);
            } else {
                $('.product-id').text(response.data.product.id);
                $('.product-detail:not(".bundle-item")').data('pid', response.data.product.id);
            }
        });
    },
    updateAddToCart: function () {
        $('body').on('product:updateAddToCart', function (e, response) {
            // update local add to cart (for sets)
            $('button.add-to-cart', response.$productContainer).attr(
                'disabled',
                (!response.product.readyToOrder || !response.product.available)
            );

            let enable = $('.product-availability').toArray().every(function (item) {
                return $(item).data('available') && $(item).data('ready-to-order');
            });
            module.exports.methods.updateAddToCartEnableDisableOtherElements(!enable);
        });
    },
    updateAvailability: function () {
        $('body').on('product:updateAvailability', function (e, response) {
            let hasErrors = !response.product.available;

            $('div.availability', response.$productContainer)
                .data('ready-to-order', response.product.readyToOrder)
                .data('available', response.product.available)
                .data('delivery-available', response.product.deliveryAvailable);

            $('.availability-msg', response.$productContainer)
                .toggleClass('text-danger', hasErrors)
                .toggleClass('text-success', !hasErrors)
                .empty()
                .html(response.message);

            if ($('.global-availability').length) {
                let allAvailable = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('available'); });

                let allReady = $('.product-availability').toArray()
                    .every(function (item) { return $(item).data('ready-to-order'); });

                let allHasDelivery = $('.product-availability').toArray()
                    .every(function (item) {
                        return $(item).data('delivery-available');
                    });

                $('.global-availability')
                    .data('ready-to-order', allReady)
                    .data('available', allAvailable)
                    .data('delivery-available', allHasDelivery);

                $('.global-availability .availability-msg').empty()
                    .html(allReady ? response.message : response.resources.info_selectforstock);
            }
        });
    },
    sizeChart: function () {
        $('.size-chart a').on('click', function (e) {
            e.preventDefault();

            let url = $(this).attr('href');
            let $prodSizeChart = $(this).closest('.size-chart').find('.size-chart-collapsible');
            if ($prodSizeChart.is(':empty')) {
                $.ajax({
                    url: url,
                    type: 'get',
                    dataType: 'json',
                    success: function (data) {
                        $prodSizeChart.append(data.content);
                    }
                });
            }

            $prodSizeChart.toggleClass('active');
        });

        let $sizeChart = $('.size-chart-collapsible');

        $('body').on('click touchstart', function (e) {
            if ($('.size-chart').has(e.target).length <= 0) $sizeChart.removeClass('active');
        });
    },
    copyProductLink: function () {
        $('body').on('click', '#fa-link', function () {
            // eslint-disable-next-line no-restricted-globals
            event.preventDefault();

            let $temp = $('<input>');

            $('body').append($temp);
            $temp.val($('#shareUrl').val()).select();
            document.execCommand('copy');
            $temp.remove();

            siteAlert.show({
                type: 'success',
                message: $('.copy-link-message').text().trim(),
                timeout: 3000
            });
        });
    },
    showProductSetItemDescription: function () {
        $('.set-item:not(.active)').hide();
        $('body').on('click', '.set-image-item', function () {
            $('.set-item').hide();
            let productId = $(this).data('pid');
            let selector = '#' + productId;
            $(selector).show();
        });
    },

    scrollToTop: function () {
        $('.body').on('click', '.set-scroll-top-button', function () {
            $(window).scrollTo(0, 0);
        });
    },
    updateInfoText: function () {
        const metaAttrBlock = $('#meta2txt');
        const DISPLAY_WORDS_COUNT = 80;

        if (metaAttrBlock) {
            let metaText = metaAttrBlock.text();
            const wordCount = metaText.split(' ').length;

            if (wordCount > DISPLAY_WORDS_COUNT) {
                metaText = getMainInfoText(metaText, DISPLAY_WORDS_COUNT);

                const wordArray = metaText.split(' ');
                const lastWord = wordArray[wordArray.length - 1];

                if (/[.,:;?!]/.test(lastWord)) {
                    wordArray.pop();
                    metaText = wordArray.join(' ');
                }

                metaText += ' <a id="readMore" href="#">...mehr lessen</a>';

                metaAttrBlock.html(metaText);
            }
        }
    },
    metaTextReadMore: function () {
        $('body').on('click', '#readMore', function (e) {
            e.preventDefault();
            const metaAttrBlock = $('#meta2txt');

            metaAttrBlock.html(metaAttrBlock.data('full-attr-text'));
        });
    },
    focusChooseBonusProductModal: base.focusChooseBonusProductModal(),
    shippingTypeChange: base.shippingTypeChange,
    shippingTypeChangeOnProductPage: base.shippingTypeChangeOnProductPage,
    handleProductStores: base.handleProductStores,
    updateShippingDetailsOnVariationChange: base.updateShippingDetailsOnVariationChange,
    copyPromotionalCode: function () {
        $('body').on('click', '#copyPromotionalCode', function (e) {
            e.preventDefault();

            let button = $(this);
            let buttonText = button.find('span');
            let code = button.data('code');

            if (code) {
                copy(code);

                buttonText.text(button.data('copied'));
                button.addClass('copied');

                setTimeout(function () {
                    buttonText.text(button.data('copy'));
                    button.removeClass('copied');
                }, 3000);
            }
        });
    },

    installmentsAccordion: function () {
        const $root = $('.pdp-installments');

        if (!$root.length) return;

        $('body').on('click', '#pdp-installments-toggle', function () {
            const $btn = $(this);
            const expanded = $btn.attr('aria-expanded') === 'true';

            $btn.attr('aria-expanded', expanded ? 'false' : 'true');
            $root.toggleClass('is-open', !expanded);
        });

        $('body').on('product:afterAttributeSelect', function (e, response) {
            const product = response && response.data && response.data.product;

            if (!product || !product.price) return;

            const canAddToBasket = product.purchasable
                && product.readyToOrder
                && product.available
                && product.deliveryAvailable
                && product.price.available;
            const isDelivery = response.container.attr('data-shipping-type') === 'delivery'
                || response.container.attr('data-is-delivery-selected') === 'true';
            const salesPrice = isDelivery && product.price.salesSet && product.price.salesSet.value != null
                ? product.price.salesSet
                : product.price.sales;
            const amount = salesPrice && salesPrice.value != null ? salesPrice.value : null;
            const minPrice = parseFloat($root.attr('data-min-price'), 10);
            const visible = canAddToBasket && amount != null && (Number.isNaN(minPrice) || amount >= minPrice);

            $root.toggleClass('d-none', !visible);

            if (!visible) return;

            const $ppMessage = $root.find('[data-pp-message]');
            const $klarnaPlacement = $root.find('klarna-placement');

            if ($ppMessage.length) {
                $ppMessage.attr('data-pp-amount', amount);

                if (window.paypal && typeof window.paypal.Messages === 'function') window.paypal.Messages({ amount: amount }).render($ppMessage.get(0));
            }

            if ($klarnaPlacement.length) {
                setTimeout(function () {
                    $klarnaPlacement.attr('data-purchase-amount', Math.round(amount * 100));

                    if (window.KlarnaOnsiteService) window.KlarnaOnsiteService.push({ eventName: 'refresh-placements' });
                }, 0);
            }
        });
    }
};
